<!-- Template for Basketball(G1), American Football(G1), Tennis(N3), Badminton(N12), Snooker(N15) and Table Tennis(N24) -->
<template>
  <!--     資料顯示的layer     -->
  <div id="showtable">
    <template v-if="!selectedMatchAllBet">
      <!-- Today RB -->
      <template v-if="selectedMarket=='1' && sortedRBEventList && (sortedRBEventList.length > 0 || Object.keys(sortedRBEventList).length > 0)">
        <todayHeader :marketType="market.inPlayMarket.key" @updateMethod="showMarketMatches"></todayHeader>
        <template v-if="showRBhideAll">
          <template v-for="(eventObj, eventObjKey) in sortedRBEventList">
            <!-- League Capt -->
            <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; top: 73.5px;">
              <div class="list-card-inner" :key="eventObjKey">
                <div class="c-match-league match-tpl0-bg"
                  :class="{ 'match-tpl0': !showRBLgeEve[eventObjKey].hide, 'leagues-pack': showRBLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, true)">
                  <!-- :class="{ 'match-tpl0': !sortedRBEventList[eventObjKey].hide, 'leagues-pack': sortedRBEventList[eventObjKey].hide }" @click="showLeg(eventObjKey, false)"> -->
                  <div class="tr-match-head">
                    <div class="leagues-wrap" style="width: 315px !important;">
                      <i size="14px" class="icon-arrow q-icon c-icon"></i>
                      <div class="league-icon-wrap">
                        <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                      </div>
                      <div class="ellipsis-wrap">
                        <div class="absolute-full">
                          <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                          <span class="league-match-count">{{ eventObj.length }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="play-name vrow col">
                      <template v-if="selectedBettype.sprtId == 'G1' || selectedBettype.sprtId == 'N1'">
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.ML'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.HDP'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.OU'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.O/E'] }}</div>
                      </template>
                      <template v-else>
                        <div class="col">{{ getBetCaption('ML') }}</div>
                        <div class="col">{{ getBetCaption('HDP') }}</div>
                        <div class="col">{{ getBetCaption('O/U') }}</div>
                        <div class="col">{{ getBetCaption('O/E') }}</div>
                      </template>
                    </div>
                    <div class="yb-flex-center" style="width: 39px !important;">
                      <div class="icon-wrap m-star-wrap-league"
                        :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"
                        @click="favouritelgeve(eventObj[0].lgeid, $event, '1', eventObj)">
                        <i class=" icon-star q-icon c-icon" :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- League Events -->
            <!-- <template v-if="!sortedRBEventList[eventObjKey].hide"> -->
            <template v-if="!showRBLgeEve[eventObjKey].hide">
              <template v-for="(event, eventKey) in eventObj">
                <template v-if="checkEventPlyTypExist2(event)">
                  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw')">
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec')">
                        <div class="c-match-item more-handicap csid-1">
                          <div class="process-col yb-flex-center">
                            <sportTime :event="event"></sportTime>
                          </div>

                          <div class="match-handicap-item-wrap">
                            <!-- sub match -->
                            <template v-for="(subMatch, subMatchKey) in getSubMatchCount(event['od'][getFullTime(event['od'])])"
                              v-if="showSubMatch(subMatch, event, subMatchKey)">
                              <div class="match-handicap-item">
                                <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :plyType="ftPlyType" :isRB="true">
                                </sportTeam>
                                <div class="c-match-handicap cmh" :id="'cmatch'+event.eveid">
                                  <div class="vrow no-wrap">
                                    <!-- FT ML -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <template v-if="event.sptid!=os1x2">
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="getFullTime(event['od'])" :betType="rmlBetType" />
                                          </template>
                                          <template v-else>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="getFullTime(event['od'])" :betType="ronex2BetType" />
                                          </template>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <template v-if="event.sptid!=os1x2">
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="getFullTime(event['od'])" :betType="rmlBetType" />
                                          </template>
                                          <template v-else>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="getFullTime(event['od'])" :betType="ronex2BetType" />
                                          </template>
                                        </div>
                                      </div>
                                      <template v-if="event.sptid==os1x2 && subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="getFullTime(event['od'])" :betType="ronex2BetType" />
                                          </div>
                                        </div>
                                      </template>
                                      <template v-if="event.sptid!=os1x2 && subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT HDP -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <handicap :event="event" :favTeam="'a'" :plyType="getFullTime(event['od'])" :betType="rhdpBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="rhdpBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <handicap :event="event" :favTeam="'b'" :plyType="getFullTime(event['od'])" :betType="rhdpBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="rhdpBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT OU -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][rouBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="rouBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="rouBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][rouBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="rouBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="rouBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT OE -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][roeBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.ODD'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <odd v-if="subMatchKey == 0" :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="roeBetType" :match="subMatchKey">
                                          </odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][roeBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.EVEN'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <odd v-if="subMatchKey == 0" :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="roeBetType" :match="subMatchKey">
                                          </odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                                <div class="media-col c-os2">
                                  <div class="media-col-wrap"  v-if="subMatchKey==0">
                                    <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                      <div class="v-icon switch-icon" @click="enterAllBet(event,1, true)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                    </div>
                                    <div class="yb-flex-center"></div>
                                    <!--div class="icon-wrap relative-position">
                                      <div class="v-icon animation-icon"></div>
                                    </div-->
                                    <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                      <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2, true)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <moreBetComponent :event="event"></moreBetComponent>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </template> <!-- END League Events -->
          </template> <!-- END sortedRBEventList -->
        </template>
      </template>

      <!-- Normal Fav/Normal Match -->
      <!-- Today/Early Not Started Match -->
      <template v-if="(sortedEventList && (sortedEventList.length > 0 || Object.keys(sortedEventList).length > 0))">
        <todayHeader :marketType="market.tdyMarket.key" @updateMethod="showMarketMatches"></todayHeader>
        <template v-if="showhideAll">
          <template v-for="(eventObj, eventObjKey) in sortedEventList">
            <!-- League Capt -->
            <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; " :style="getTop()">
              <div class="list-card-inner" :key="eventObjKey">
                <div class="c-match-league match-tpl0-bg"
                  :class="{ 'match-tpl0': !showLgeEve[eventObjKey].hide, 'leagues-pack': showLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, false)">
                  <!-- :class="{ 'match-tpl0': !sortedEventList[eventObjKey].hide, 'leagues-pack': sortedEventList[eventObjKey].hide }" @click="showLeg(eventObjKey, false)"> -->
                  
                  <div class="tr-match-head">
                    <div class="leagues-wrap" style="width: 315px !important;">
                      <i size="14px" class="icon-arrow q-icon c-icon"></i>
                      <div class="league-icon-wrap">
                        <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                      </div>
                      <div class="ellipsis-wrap">
                        <div class="absolute-full">
                          <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                          <span class="league-match-count">{{ eventObj.length }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="play-name vrow col">
                      <template v-if="selectedBettype.sprtId == 'G1'">
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.ML'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.HDP'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.OU'] }}</div>
                        <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_8.FT.O/E'] }}</div>
                      </template>
                      <template v-else>
                        <div class="col">{{ getBetCaption('ML') }}</div>
                        <div class="col">{{ getBetCaption('HDP') }}</div>
                        <div class="col">{{ getBetCaption('O/U') }}</div>
                        <div class="col">{{ getBetCaption('O/E') }}</div>
                      </template>
                    </div>
                    <div class="yb-flex-center" style="width: 39px !important;">
                      <div class="icon-wrap m-star-wrap-league"
                        :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"
                        @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                        <i class=" icon-star q-icon c-icon"
                          :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- League Events -->
            <template v-if="!showLgeEve[eventObjKey].hide">
            <!-- <template v-if="!sortedEventList[eventObjKey].hide"> -->
              <template v-for="(event, eventKey) in eventObj">
                <template v-if="checkEventPlyTypExist2(event)">
                  <div class="list-card-wrap v-scroll-item relative-position evecardwrap" :id="'eCardWrap'+event.eveid" :ref="'eCardWrap'+event.eveid" :style="eventHeight(event, 'ecw')">
                    <div class="list-card-inner">
                      <div class="c-match-card relative-position evecard" :id="'eCard'+event.eveid" :ref="'eCard'+event.eveid" :style="eventHeight(event, 'ec')">
                        <div class="c-match-item more-handicap csid-1">
                          <div class="process-col yb-flex-center">
                            <sportTime :event="event"></sportTime>
                          </div>

                          <div class="match-handicap-item-wrap">
                            <template
                              v-for="(subMatch, subMatchKey) in getSubMatchCount(event['od'][getFullTime(event['od'])])"
                              v-if="showSubMatch(subMatch, event, subMatchKey)">
                              <div class="match-handicap-item">
                                <sportTeam :event="event" :issc="true" classes="none" :subMatchKey="subMatchKey" :plyType="ftPlyType" :isRB="false">
                                </sportTeam>
                                <div class="c-match-handicap cmh" :id="'cmatch'+event.eveid">
                                  <div class="vrow no-wrap">
                                    <!-- FT ML --> 
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <template v-if="event.sptid!=os1x2">
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="getFullTime(event['od'])" :betType="mlBetType" />
                                          </template>
                                          <template v-else>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamHome" :plyType="getFullTime(event['od'])" :betType="onex2BetType" />
                                          </template>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                          <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <template v-if="event.sptid!=os1x2">
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="getFullTime(event['od'])" :betType="mlBetType" />
                                          </template>
                                          <template v-else>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamAway" :plyType="getFullTime(event['od'])" :betType="onex2BetType" />
                                          </template>
                                        </div>
                                      </div>
                                      <template v-if="event.sptid==os1x2 && subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                          <div class="c-bet-item yb-flex-center relative-position yb-family-odds hm no-handicap normal csid2 show-odds-icon">
                                            <div class="handicap-value" style="position: absolute;margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text"></div>
                                            </div>
                                            <odd1x2 v-if="subMatchKey == 0" :event="event" :team="teamDraw" :plyType="getFullTime(event['od'])" :betType="onex2BetType" />
                                          </div>
                                        </div>
                                      </template>
                                      <template v-if="event.sptid!=os1x2 && subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT HDP -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <handicap :event="event" :favTeam="'a'" :plyType="getFullTime(event['od'])"
                                                :betType="hdpBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="hdpBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more" style="display: none;">&nbsp;</span>
                                            <div class="handicap-value-text">
                                              <handicap :event="event" :favTeam="'b'" :plyType="getFullTime(event['od'])" :betType="hdpBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="hdpBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT OU -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template v-if="chkOddCaption(event, subMatchKey, ouBetType)">
                                                {{ sportTableLang.table['SPORT_TABLE.OVER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template v-if="chkOddCaption(event, subMatchKey, ouBetType)">
                                                {{ sportTableLang.table['SPORT_TABLE.UNDER'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text">
                                              <over-under :event="event" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey" />
                                            </div>
                                          </div>
                                          <odd :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="ouBetType" :match="subMatchKey"></odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                    <!-- FT OE -->
                                    <div class="handicap-col hc-os2">
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][oeBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.ODD'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <odd v-if="subMatchKey == 0" :event="event" :team="teamA" :plyType="getFullTime(event['od'])" :betType="oeBetType" :match="subMatchKey">
                                          </odd>
                                        </div>
                                      </div>
                                      <div class="bet-item-wrap" style="height: 35px !important;">
                                        <div
                                          class="c-bet-item yb-flex-center relative-position yb-family-odds hm normal csid1 show-odds-icon">
                                          <div class="handicap-value color-highlight" style="position: absolute;margin-right: 40px;">
                                            <span class="handicap-more">
                                              <template
                                                v-if="subMatchKey == 0 && event.od[getFullTime(event['od'])] && event.od[getFullTime(event['od'])][oeBetType]">
                                                {{ sportTableLang.table['SPORT_TABLE.EVEN'] }}
                                              </template>
                                              &nbsp;
                                            </span>
                                            <div class="handicap-value-text"></div>
                                          </div>
                                          <odd v-if="subMatchKey == 0" :event="event" :team="teamB" :plyType="getFullTime(event['od'])" :betType="oeBetType" :match="subMatchKey">
                                          </odd>
                                        </div>
                                      </div>
                                      <template v-if="subMatchKey == 0">
                                        <div class="bet-item-wrap" style="height: 35px !important;">
                                        </div>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                                <div class="media-col c-os2">
                                  <div class="media-col-wrap" v-if="subMatchKey==0">
                                    <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                      <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <moreBetComponent :event="event"></moreBetComponent>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </template> <!-- END League Events -->
          </template> <!-- END sortedEventList -->
        </template>
      </template>

    </template>
    <template v-else>
      <otherSportAllCommon2></otherSportAllCommon2>
    </template>
    <div class="" v-if="(sortedEventList && Object.keys(sortedEventList).length > 0)">
      <div style="height: 15px;"></div>
      <div class="pager-wrap vrow justify-end">
        <div class="go-top-btn yb-flex-center" @click="backtoTop">
          <i aria-hidden="true" role="presentation" class="q-icon icon-go_top c-icon" style="font-size: 14px;"></i>
          <div class="vmsg">{{ lang.sportAllBet['ALL_BET.BACK_TOP'] }}</div>
        </div>
      </div>
    </div>
    <div class="absolute-full resize-observer-wrap">
      <div class="absolute-full expand"></div>
      <div class="absolute-full shrink"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'
import otherSportAllCommon2 from './otherSportAllCommon2'

// import moreBetComponent from './allBet/more-bet'
import moreBetComponent from './allBet/more-bet-other-sport'

import sportTeam from './sportTeamColumn'
import sportTime from './sportTimeColumn'
import todayHeader from './todayHeader'

import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [sportFavourite, allBetMixin],
  data() {
    return {
      plytyp: null,
      lang: window.lang,
      showhideAll: true,
      showRBhideAll: true,
      moreBetEveId: null,
      os1x2: '19',
    }
  },
  components: {
    sportTime,
    sportTeam,
    otherSportAllCommon2,
    moreBetComponent,
    todayHeader,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sortedEventList',
      'sortedRBEventList',
      'sortedFavRbEventList',
      'sortedMatchEventList',
      'selectedMarket',
      'selectedBettype',
      'selectedMatchAllBet',
      'selectedAllBetNew',
      'moreBetLoading',
      'favouriteLgeEvents',
      'market',
      'livetv',
      'firstEvent',
      'account',
      'showFavEvents',
      'showRBLgeEve',
      'showLgeEve',
      'isParlayTab',
      'tvIconFlag',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },

  },
  methods: {
    chkOddCaption(event, subMatchKey, bettype){
      var res = false
      var sm = ''
      if(subMatchKey==0){
        sm = 'a'
      }else if(subMatchKey==1){
        sm = 'b'
      } else if(subMatchKey==2){
        sm = 'c'
      } else if(subMatchKey==3){
        sm = 'd'
      }
      if(event.od[this.getFullTime(event['od'])] && event.od[this.getFullTime(event['od'])][bettype] && event.od[this.getFullTime(event['od'])][bettype][sm]){
        res = true
      }
      return res
    },
    showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll
      } else {
        this.showhideAll = !this.showhideAll
      }
    },
    getTop(){
      var topVal = (this.selectedMarket == this.$store.getters.market.tdyMarket.key && (this.$store.getters.selectedBettype.betTypId != 5 || !this.isParlayTab)) ? '73.5' : '89.5'

      return 'top:'+topVal+'px'
    },
    showhideMain(isRB) {
      var key = ''
      if (!isRB) {
        this.showhideAll = (this.showhideAll) ? false : true;
        for (key in this.sortedEventList) {
          this.$set(this.sortedEventList[key], 'hide', !showhideAll)
        }
      }
      if (this.showFavEvents && isRB) {
        this.showRBhideAll = (this.showRBhideAll) ? false : true;
        if (this.showFavEvents) {
          for (key in this.sortedFavRbEventList) {
            this.$set(this.sortedFavRbEventList[key], 'hide', !showRBhideAll)
          }
        }
      }
    },
    getBetCaption(bt) {
      return this.sportTableLang.template_lang['SPORT_TEMPLATE_' + this.selectedBettype.tmpltId + '.' + bt]
    },
    showLeg(key, isRB) {
      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide)
        // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      } else if (isRB) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide)
        // this.$set(this.sortedRBEventList[key], 'hide', !this.sortedRBEventList[key].hide)
      }

      // if (this.showFavEvents && isRB) {
      //   this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide)
      // }
    },
    openAllBetForm(event) {
      this.$store.dispatch('getSportAllBet', { event: event })
    },
    countAllBet(event) {
      var countCv = event.all;
      var loop = 0;
      if (event.od) {
        $.each(event.od, function (plyTypes, drawBt) {
          if (loop < 1) {
            $.each(drawBt, function (bidx, drawDual) {
              if (bidx == 1 || bidx == 2 || bidx == 8 || bidx == 9 || bidx == 3 || bidx == 10) {
                $.each(drawDual, function (dd, val) {
                  --countCv;
                });
              } else if (event.sptid == "3" || event.sptid == "12" || event.sptid == "2" || event.sptid == "15" || event.sptid === "21") {
                --countCv; // moneline
              }
            });
            loop = 1;
          }
        });
      }
      return countCv;
    },
    openMoreBetForm(event) {
      $('.moreB').css("display", "none");
      this.$store.commit('SELECTED_ALLBETNEW', false)
      var expanded = $('#moreExpand' + event.eveid).hasClass('icon-moreExpand')
      this.moreBetEveId = event.eveid
      if (expanded) {
        $('#moreBets' + event.eveid).css("display", "");
        this.$store.commit('MOREBETLOADING', true)
        $('.moreExpd').removeClass('icon-moreCollapse')
        $('.moreExpd').addClass('icon-moreExpand')
        $('#moreExpand' + event.eveid).removeClass('icon-moreExpand')
        $('#moreExpand' + event.eveid).addClass('icon-moreCollapse')
        this.$store.dispatch('getSportAllBet', {
          event: event,
          token: token.arr_8,
          callback: ((res) => {

          }).bind(this)
        })
      } else {
        $('#moreExpand' + event.eveid).addClass('icon-moreExpand')
        $('#moreExpand' + event.eveid).removeClass('icon-moreCollapse')
        $('#moreBets' + event.eveid).css("display", "none");
      }
    },
    isPrior(event, plytyp) {
      if (this.$store.getters.selectedBettype.sprtId == 'G2') {
        return false
      } else if (event.prior.indexOf(parseInt(plytyp)) >= 0) {
        return true;
      }
      return false;
    },
    enterMatch(event) {
      this.$store.commit('SELECTED_MATCHALLBET', true)

      this.$store.dispatch('getMatchAllBet', {
        event: event,
        token: token.arr_8,
      })
    },
    enterAllBet(event,startTv, isRB=false) {
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      EventBus.$emit('activeRbScoreBoard');
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: isRB,
        // isRB: (event.rbinfo) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
    },
    backtoTop() {
      // $(".list-scrollbar").animate({ scrollTop: 0 },100);
      $(".sport-table-scroll").animate({ scrollTop: 0 },100);
    },
    // eventHeight(eveData, eCard){
    //   // morebet:32|submatch:70|main:105
    //   var subH = 0
    //   var card = (eCard=='ecw') ? 5 : 2
    //   var exist = false //this.chkMoreBetExist(eveData)
    //   var morebet = (exist) ? 32 : 0
    //   var OSsub = 0
    //   if(eveData.sptid != 1){
    //     // OSsub = this.getSubMatchCount(eveData['od'][this.getplytype(eveData['od'])])
    //     OSsub = eveData.sub + 1
    //   }
      
    //   if(eveData.sptid != 1 && OSsub>0){
    //     subH = 105 + (OSsub * 70) + card + morebet
    //   }

    //   return 'height: '+subH+'px'
    // },
  },
  mounted() {
    EventBus.$on('sportChange', ((params) => {
      this.checkPlayType()
    }).bind(this))
    //allBetMixin
    this.checkPlayType()
    EventBus.$emit('refreshOdd', true)
  },
  updated() {
    // if (this.selectedBettype.tmpltId == '8' || this.selectedBettype.tmpltId == '7') {
    //   $('#showtable').children().closest('.evecardwrap').each(function () {
    //     var a = jQuery(this).find(".evecard").height()
    //     if (a > 0) {
    //       jQuery(this).find(".evecard").height(a)
    //       jQuery(this).height(a + 5)
    //     }
    //   });
    // }
  },
  destroyed() {
    
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/otherSportCommon2.vue